/*
 TemplateList component
 url match: /dashboard/templates
 Displays a list of all available templates with options to edit and
 set them up - Admins
 Additionally, allows Super Admins to create/delete templates 
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import Images from '../../Theme/Images';
import { withStyles } from '@material-ui/core/styles';
import { templateStyles } from '../../Styles/templateStyles';
import { ReactSVG } from 'react-svg';
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader-spinner'
import Header from '../../Common/Header'
import AddIcon from '@material-ui/icons/Add';
import UploadTemplate from './UploadTemplate';
import DeleteDialog from '../../Common/DeleteDialog';
import Tooltip from '@material-ui/core/Tooltip';

@inject('templateStore', 'commonStore', 'userStore')
@observer
class TemplateList extends React.Component {
    state = {
        deleteDialog: false,
        currentTemplate: {}
    }
    componentDidMount() {
        this.props.commonStore.setActiveTab('templates');
        this.props.templateStore.getTemplateList()
    }

    openUploadDialog = () => {
        this.props.templateStore.openUploadDialog(true)
    }

    deleteTemplate = (e, template) => {
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        this.setState({ currentTemplate: template, deleteDialog: true })
    }

    confirmDelete = () => {
        this.props.templateStore.deleteTemplate(this.state.currentTemplate._id)
    }

    cancelDelete = () => {
        this.setState({ deleteDialog: false })
    }

    renderList = (k) => {
        const { user } = this.props.userStore
        let start = k;
        start = start == 0 ? start : (start == 1 ? 5 : start * 6 - 1);
        let end = start == 0 ? start + 4 : start + 5
        const { templateList } = this.props.templateStore;
        const { classes } = this.props;

        return (
            <React.Fragment>
                {
                    start == 0 && user.userType === 'SUPER_ADMIN' ?
                        <div className={classes.img} style={{ margin: '0vh 1.5vw', height: '163px', borderRadius: '8px' }} onClick={(e) => this.openUploadDialog()}>
                            <AddIcon fontSize="large" style={{ margin: '0 auto' }} />
                            <div style={{ textAlign: 'center' }}>Create new</div>
                        </div> : null
                }
                {templateList.length ?
                    templateList.slice(start, end + 1).map((row, index) => (
                        <div key={index} className={classes.addTemplate} onClick={(e) => this.getTemplateDetails(row)}>
                            <div className={classes.imgContainer}><img alt={row.templateName} className={classes.img} src={row.imagePreview} /> </div>
                            <div className={classes.iconContainer} style={{ justifyContent: 'space-between' }}>
                                <div className="rowFlex">
                                    {row.exportMappingFlag ? <ReactSVG src={Images.check} className={classes.tickIcon} /> : null}
                                    <ReactSVG src={Images.edit} className={classes.editIcon} /> </div>
                                {user.userType === 'SUPER_ADMIN' ?
                                    <ReactSVG onClick={(e) => this.deleteTemplate(e, row)} className={classes.deleteIcon} src={Images.docDelete} /> : <ReactSVG src={Images.check} style={{ visibility: 'hidden' }} />
                                }
                            </div>
                            <Tooltip title={row.templateName}>
                                <div className={classes.templateName}>{row.templateName}</div>

                            </Tooltip>
                            <div style={{ fontSize: '10px', color: '#9ea7b9' }}>Output: {row.exportOutputFormat}</div>
                        </div>
                    ))
                    : null}
            </React.Fragment>
        )
    }

    getTemplateDetails = (temp) => {
        /*if (temp.templateCompleteStatus)
            this.props.history.push(`/template/mapping/${temp._id}`)
        else*/
        this.props.history.push(`/template/${temp.localTemplateId}`)

    }


    renderTemplateList = () => {
        const { classes } = this.props;
        const { templateList } = this.props.templateStore;
        return (
            <div>
                {
                    Array.from({ length: Math.ceil(templateList.length / 6 + 1) }, (_, k) => (
                        <div key={k} className={classes.templatesContainer}>
                            {
                                this.renderList(k)
                            }

                        </div>
                    ))
                }

            </div>
        )
    }

    render() {
        const { classes } = this.props;
        const { inProgress } = this.props.templateStore;
        const { deleteDialog } = this.state;
        if (inProgress)
            return (
                <div style={{ height: '100%' }}>
                    <div className={classes.headerContainer}>
                        <Typography className={classes.header}>{this.props.heading}</Typography>
                        <Header searchType="docs" filter={this.props.filter}></Header>
                    </div>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <div style={{ height: '100%' }}>
                <div className={classes.headerContainer}>
                    <Typography className={classes.header}>Templates</Typography>
                    <Header filter={this.props.filter}></Header>
                </div>
                <div>
                    {this.renderTemplateList()}
                </div>
                <UploadTemplate></UploadTemplate>
                <DeleteDialog open={deleteDialog} title="Delete template" message="Are you sure you want to delete this template?" delete={this.confirmDelete} cancelDelete={this.cancelDelete}></DeleteDialog>
            </div>
        );
    }
}

export default withStyles(templateStyles, { withTheme: true })(withRouter(TemplateList));
